import * as d3 from 'd3'

export default {
  methods: {
    call_Page(selection, page, data) {
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(50).attr('opacity', .5)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(50).attr('opacity', 1)
      })
      .on('click', () => {

        d3.selectAll('.CHART_CANVAS').remove()

        if(page=='OVERALL') {
          this.current.tab = 'OVERALL'

          d3.select('#BTN-ITR').transition().duration(200).attr('fill', '#E0E0DF')
          d3.select('#FORM-ITR').transition().duration(300).attr('opacity', 0)
          d3.select('#FORM-ITR').transition().delay(300).attr('visibility', 'hidden')

          d3.select('#BTN-OVERALL').transition().duration(200).attr('fill', '#B4E3FA')
          d3.select('#FORM-OVERALL').attr('visibility', 'display')
          d3.select('#FORM-OVERALL').transition().duration(300).attr('opacity', 1)
          this.chartRouter(data, 'B')
        } else if(page=='ITR') {
          this.current.tab = 'ITR'

          d3.select('#BTN-OVERALL').transition().duration(200).attr('fill', '#E0E0DF')
          d3.select('#FORM-OVERALL').transition().duration(300).attr('opacity', 0)
          d3.select('#FORM-OVERALL').transition().delay(300).attr('visibility', 'hidden')

          d3.select('#BTN-ITR').transition().duration(200).attr('fill', '#B4E3FA')
          d3.select('#FORM-ITR').attr('visibility', 'display')
          d3.select('#FORM-ITR').transition().duration(300).attr('opacity', 1)
          this.draw_Donuts(this.canvasBoundary, data)
          this.chartRouter(data, 'P07')
          this.chartRouter(data, 'I01')
        }
      })
    },


    call_Legends(selection) {
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(50).attr('opacity', .5)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(50).attr('opacity', 1)
      })
      .on('click', () => {

      })
    },



    event_Link(selection, data_, code_, req_, filter_) {
      
      if (data_[code_] == 0) return

      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(50).style('fill', '#EC407A')
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(50).style('fill', '#333')
      })
      .on('click', (event, d) => {
        event.stopPropagation()
        this.link_Action({
          data: data_,
          code: code_,
          reqText: req_,
          filterText: filter_,
        })
      })
    },



    link_Action(props) {

      let dataSource = {}

      Object.keys(this.keys).forEach(d=>{
        dataSource = {...dataSource, [d]: props.data[this.keys[d]]}
      })
      let filterString_ = props.filterText || ''
      let requestText = (props.reqText && props.reqText != '') ? props.reqText : 'request'

      // seting request_ from A/G jsonProps
      let request_ = this.getRequestColumnProps(requestText, dataSource, this.ColumnProps)
      if(!request_) return

      if(request_.iFilters.filterString) {
        request_.iFilters.filterString += filterString_ ? ` AND ${filterString_} ` : ''
      } else {
        request_.iFilters.filterString = filterString_||''
      }

      // Combine filterStrings
      request_ = {...request_,
        filters : {
          ...this.FilterValues,
          ...request_.filters,
        },
        iFilters: { 
          filterString : request_.iFilters.filterString||'',
          inputFilter : request_.iFilters.inputFilter,},
      }
      this.$emit('request-action', request_)
    },
    
  }
}